import React, { Component, useState, useEffect } from "react";
import Slider from "react-slick";
import { SVGIcons, ImgIcons, Imgbanner } from "../../Helpers/Common";
import { Link } from "react-router-dom";
import { Watchtrailerdetails } from "../../components/vidjs/mainPlayer";
import { Addtowatchlistaction, Checkuserwatchlist } from "../../Model/Users";
import { GetPlayurl } from "../../Model/Content"; //Include Home
import { Bannerplayer } from "../../components/vidjs/mainPlayer";
import { toast } from "react-toastify";
var SVGIcon = "";
var ImageData = "";

SVGIcons().then((resultData) => (SVGIcon = resultData));
ImgIcons().then((result) => (ImageData = result));

export function Showdetailspopup(props) {
  const [Addtowatchlist, setAddtowatchlist] = useState(false);
  const [player, setplayer] = useState(false);
  const [PlayURLbtn, setPlayURLbtn] = useState(false);
  const [PlayURLbtndata, setPlayURLbtndata] = useState(false);
  function PlayURL(content_id, content_type) {
    var Postdata = {
      content_id: content_id,
      seesionID: localStorage.getItem("session_id"),
      userID: localStorage.getItem("userID")
    };

    GetPlayurl(Postdata).then((PlayURLresponse) => {
      setPlayURLbtndata(PlayURLresponse);

      if (PlayURLresponse) {
        setPlayURLbtn(true);
        if (PlayURLresponse.data.subtitles) {
          content = PlayURLresponse.data;
        }
        var videoURL = PlayURLbtndata;
        if (videoURL.statusCode == "403") {
          return <p>No content found</p>;
        }
        var content = videoURL.content;
      }
    });
  }
  useEffect(() => {
    var Postdata = {
      content_id: props.data.ID,
      session_id: localStorage.getItem("session_id"),
      userID: localStorage.getItem("userID")
    };
    Checkuserwatchlist(Postdata).then((res) => {
      var Response = JSON.parse(res.data);
      if (Response.iswatched == true) {
        setAddtowatchlist(true);
      }
    });
  }, []);

  function watchtrailer() {
    setplayer(true);
  }

  let closePlayer = () => {
    // setPlayer(false)
    var element = document.getElementById("LiveTVplayer");
    setplayer(false);
    props.Closebtn();
  };

  function addtowatchlist() {
    if (Addtowatchlist == true) {
      //Remove from watchlist

      setAddtowatchlist(false);
      var data = {
        content_id: [props.data.ID],
        action: "delete",
      };
    } else {
      //Add To watchlist
      var data = {
        content_id: [props.data.ID],
        action: "add",
      };
      setAddtowatchlist(true);
    }

    Addtowatchlistaction(data).then((Response) => {
      if (Addtowatchlist == true) {
        setAddtowatchlist(false);

        toast("Removed from Watchlist", {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeButton: false,
          draggable: true,
          theme: "light",
          className: "toast-message",
        });
      } else {
        //Add To watchlist
        setAddtowatchlist(true);
        toast("Added to Watchlist", {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeButton: false,
          draggable: true,
          theme: "light",
          className: "toast-message",
        });
      }
    });
  }
  var Today = new Date();

  var Releasing_Date = new Date(props.data.publish_start_date).getTime();
  Today = new Date(Today).getTime();

  if (Releasing_Date > Today) {
    //releasing soon
    var ShowReleasing = true;
  } else {
    var ShowReleasing = false;
  }
  return (
    <>
      {PlayURLbtn && PlayURLbtndata ? (
        <Bannerplayer
          data={PlayURLbtndata.data.url.video_url}
          subtitles={PlayURLbtndata.data.subtitles}
          post={props.data.banner_image.medium}
          functionclose={closePlayer}
          autoPlay={true}
        />
      ) : null}
      {player ? (
        <Watchtrailerdetails
          data={props.data.promo_url}
          post={props.data.banner_image.medium}
          functionclose={closePlayer}
          Contentdata={props.data}
        />
      ) : null}
      <div className="detail-page-popup" id="detail-popup">
        <div className="temp69-modal-body">
          <button className="temp69-modal-close temp69-modal-toggle">
            <img
              src={SVGIcon["promocode-close.svg"]}
              alt="DocuBay"
              onClick={props.Closebtn}
            />
          </button>
          <div className="temp69-left">
            {ShowReleasing ? (
              <>
                <img
                  src={props.data.vertical_banner.medium}
                  alt="DocuBay"
                  className="imgPass"
                />
                <img src={ImageData["lockIcon.png"]} className="temp69-po" />
              </>
            ) : (
              <Link to={"/playcontent/" + props.data.slug}>
                <img
                  src={props.data.vertical_banner.medium}
                  alt="DocuBay"
                  className="imgPass"
                />
                <img src={SVGIcon["temp69-po-btn.svg"]} className="temp69-po" />
              </Link>
            )}
          </div>
          <div className="temp69-awesome">
            <div className="title">
              <h5>{props.data.title}</h5>
            </div>
            <h6>
              {/* <span className="dot">  */}
              {props.data.new ? (
                <>
                  New
                  <span className="dot" />
                </>
              ) : null}
              {props.data.awards != "" ? (
                <>
                  <img src={SVGIcon["wincup.svg"]} /> <span className="dot" />
                </>
              ) : null}
              {props.data.release_date ? <>
                {props.data.release_date}
                {props.data.content_type == "EPISODE" ? null :
                  <span className="dot" />
                }
              </> : null}
              {props.data.duration / 60 == 0
                ? ""
                : `${props.data.duration / 60} Mins`}
              {!props.data.premium && !props.data.original_tag ? (
                <>
                  &nbsp; Free
                </>
              ) : null}
              {props.data.video_4k ? (
                <span className="fBay1">4K</span>
              ) : props.data.video_hd ? (
                <span className="fBay1">HD</span>
              ) : null}
            </h6>
            <div className="temp69-rightInn">
              {props.data.premium && !props.data.original_tag ? (
                <div className="temp69-rightInn-img">
                  <img
                    src={props.silverIcon}
                    className="temp69-imgwidth"
                    alt="DocuBay"
                  />
                </div>
              ) : null}
              {props.data.premium && props.data.original_tag ? (
                <div className="temp69-rightInn-img">
                  <img
                    src={props.goldenIcon}
                    className="temp69-imgwidth"
                    alt="DocuBay"
                  />
                </div>
              ) : null}

              <div className="lBay lbg">
                {props.data.content_category} {props.data.age_restriction}
              </div>
              <div className="lBay">{props.data.genres_assign[0].name}</div>
              <div className="lBay">{props.data.keywords.split(",")[0]}</div>
            </div>
            <Link to={"/" + props.data.slug}>
              <p>{props.data.short_description}</p>
            </Link>
          </div>
          <div className="temp69-trailer">
            <Link to={"/watchtrailer/" + props.data.slug}>
              <div
                className="temp69-trailerBtn"
              // onClick={() => {
              //   watchtrailer();
              // }}
              >
                {" "}
                <img src={SVGIcon["trailer-btn.svg"]} alt="" /> Trailer{" "}
              </div>
            </Link>
            <div onClick={addtowatchlist} className="temp69-trailerBtn">
              {Addtowatchlist ? (
                <img src={SVGIcon["red-right.svg"]} />
              ) : (
                <img src={SVGIcon["watchlist-btn.svg"]} />
              )}
              Watchlist
            </div>
          </div>
          <Link to={"/" + props.data.slug}>
            <div className="temp69-details-more">
              <div className="temp69-details-more1">
                <img src={SVGIcon["wave-left.svg"]} />
                <div className="info-mobile">More Info</div>
              </div>

              <div className="temp69-details-more2">
                <img src={SVGIcon["right-arrow.svg"]} />
              </div>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
}

export default Showdetailspopup;
